import React, { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";

const k = (text) => ({ text, className: "t-key" });
const s = (text) => ({ text, className: "t-str" });
const p = (text) => ({ text });

const script = [
  { cmd: "whoami" },
  { out: [s("yaseen"), p(" — full-stack engineer · Dubai")] },
  { cmd: "cat stack.json" },
  { out: [p("{")] },
  { out: [p("  "), k('"frontend"'), p(": ["), s('"React"'), p(", "), s('"Next.js"'), p(", "), s('"TS"'), p("],")] },
  { out: [p("  "), k('"backend"'), p(":  ["), s('"Node"'), p(", "), s('"NestJS"'), p(", "), s('"Odoo"'), p("],")] },
  { out: [p("  "), k('"infra"'), p(":    ["), s('"Docker"'), p(", "), s('"CI/CD"'), p("]")] },
  { out: [p("}")] },
  { cmd: "./status --now" },
  { out: [{ text: "● ", className: "t-live" }, p("open to new opportunities")] }
];

const Terminal = ({ start = true }) => {
  const reduceMotion = useReducedMotion();
  const [line, setLine] = useState(reduceMotion ? script.length : 0);
  const [chars, setChars] = useState(0);

  useEffect(() => {
    if (!start || line >= script.length) return undefined;
    const current = script[line];
    if (current.cmd && chars < current.cmd.length) {
      const id = setTimeout(() => setChars((c) => c + 1), 45 + Math.random() * 50);
      return () => clearTimeout(id);
    }
    const id = setTimeout(
      () => {
        setLine((l) => l + 1);
        setChars(0);
      },
      current.cmd ? 320 : line === 0 ? 900 : 110
    );
    return () => clearTimeout(id);
  }, [start, line, chars]);

  const done = line >= script.length;

  return (
    <div className="terminal" role="img" aria-label="Terminal summarizing Yaseen's stack and availability">
      <div className="terminal__bar">
        <span className="terminal__dots" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
        <span className="terminal__title">~/yaseen — zsh</span>
      </div>
      <pre className="terminal__body" aria-hidden="true">
        {script.slice(0, Math.min(line + 1, script.length)).map((entry, i) => {
          const isTyping = i === line;
          if (entry.cmd) {
            return (
              <div key={i} className="terminal__line">
                <span className="t-prompt">→</span> <span className="t-path">~</span>{" "}
                {isTyping ? entry.cmd.slice(0, chars) : entry.cmd}
                {isTyping && <span className="terminal__caret" />}
              </div>
            );
          }
          if (isTyping) return null;
          return (
            <div key={i} className="terminal__line">
              {entry.out.map((seg, j) => (
                <span key={j} className={seg.className}>
                  {seg.text}
                </span>
              ))}
            </div>
          );
        })}
        {done && (
          <div className="terminal__line">
            <span className="t-prompt">→</span> <span className="t-path">~</span>{" "}
            <span className="terminal__caret" />
          </div>
        )}
      </pre>
    </div>
  );
};

export default Terminal;
